import React from "react";
import "./loading.css";

function Loading() {
  return <div className="loading-overlay">Loading...</div>;
}

export default Loading;
